$(document).ready(function () {
  let sizeIds = {};
  let sizePrice = {};
  let sizeOneTimeDiscount = {};
  let sizeHideSubscription = {};

  $(".btn-primary.AddToCart").each(function () {
    const btnAtc = $(this);
    const productId = btnAtc.attr("id").split("_")[1];
    const sectionId = btnAtc.data("sectionId");
    const btnId = btnAtc.attr("id");
    const sizeSelector = $(`#size-selector_${productId}_${sectionId}`);

    // Prevent form submission if no flavor is selected
    btnAtc.on("click", function (event) {
      const form = btnAtc.closest("form");
      // Optionally, remove the other input values based on the button clicked
      console.log("btnId", btnId);
      if (btnId === `subs_${productId}_${sectionId}`) {
        let dataInput = $(`input#selling_plan_${productId}_${sectionId}`).data(
          "selling-plan-id"
        );
        $(`#size_variant_id_${productId}_${sectionId}`).val(dataInput);
      } else if (btnId === `once_${productId}_${sectionId}`) {
        $(`#size_variant_id_${productId}_${sectionId}`).val("");
      }
    });

    sizeSelector.on("change", function () {
      sizeIds = {};

      $(`input.once-product-variants_${productId}_${sectionId}`).map(function () {
        let title = $(this).data("variant-title");
        let id = $(this).data("variant-id");
        let price = $(this).data("variant-price");
        let oneTimeDiscount = $(this).data("one-time-discount");
        let hideSubscription = $(this).data("hide-subscription");

        if (title && id) {
          sizeIds[title] = id;
        }

        if (price && id) {
          sizePrice[id] = price;
        }

        if (oneTimeDiscount && id) {
          sizeOneTimeDiscount[id] = oneTimeDiscount;
        }

        if (hideSubscription && id) {
          sizeHideSubscription[id] = hideSubscription;
        }
      });
      if (sizeSelector.val()) {
        let searchVar = sizeSelector.val();
        updateSize(searchVar, productId, sectionId);
      }
    });
  });
  function getValue(obj, key) {
    return obj[key];
  }
  
  if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

if (typeof Shopify.formatMoney !== 'function') {
  Shopify.formatMoney = function(cents, format = "${{amount}}") {
    const value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  };
}

  function updateSize(searchTerm, productId, sectionId) {
    const MatchId = findId(searchTerm);
    const MatchPrice = getValue(sizePrice, MatchId);
    const MatchPriceOneTimeDiscount = getValue(sizeOneTimeDiscount, MatchId);
    const MatchHideSubscription = getValue(sizeHideSubscription, MatchId);

    if ( MatchHideSubscription == "hide" ) {
      $(".btn__price.subs" + productId).closest('.subs').addClass('hide').addClass('hidden');
    } else {
      $(".btn__price.subs" + productId).closest('.subs').removeClass('hide').removeClass('hidden');
    }

    if (MatchId) {
      $(`#variant_id_${productId}_${sectionId}`).val(MatchId);
    }

    // +MatchPrice
    if (MatchPrice) {
      let formattedPrice = Shopify.formatMoney(+MatchPrice, "${{amount}}");
      if ( MatchPriceOneTimeDiscount >= 0) {
        let OneTimeDiscountPercent = MatchPriceOneTimeDiscount / 100;
        let OneTimeDiscountSavings = MatchPrice * OneTimeDiscountPercent;
        let OneTimeDiscountDiscounted = MatchPrice - OneTimeDiscountSavings;
        
        $(".btn__price.orig" + productId).html('<s>' + formattedPrice + '</s>');
        
          $(".btn__price.orig" + productId).show();

        formattedPrice = Shopify.formatMoney(OneTimeDiscountDiscounted, "${{amount}}");
      } else {
          $(".btn__price.orig" + productId).hide();
      }

      let discountPrice = Shopify.formatMoney(
        +MatchPrice * 0.75,
        "${{amount}}"
      );
      $(".btn__price.once" + productId).text(formattedPrice);
      $(".btn__price.subs" + productId).text(discountPrice);
    }
  }

  function findId(searchTerm) {
    // Create a case-insensitive regular expression
    const regex = new RegExp(searchTerm, "i");

    // Iterate over the variantIds object
    for (const [key, value] of Object.entries(sizeIds)) {
      if (regex.test(key)) {
        return value; // Return the ID of the first matching key
      }
    }

    return null; // Return null if no match is found
  }

  $('.size-selector').trigger('change');
});
